import React, { useCallback, useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box, Button, Typography } from '@mui/material'
import StatusCustom from '../../../../components/status/statusCustom'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { booked_book, ELibraryManagementApi } from '../../../../api/e-library/e_library_management'
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal'
import { routeName } from '../../../../routes/routeName'
import { RootState } from '../../../../store/store'
import StateComponents from '../../../../components/state-component/StateComponents'
import { LIBRARY_DETAIL_TYPE, LIBRARY_HISTORY_STATUS } from '../../enum/elibrary_enum'
import ModalCustom from '../../../../components/modal/modalCustomCms'
import TableCustom from '../../../../components/table/tableCustom'
import { useTranslation } from 'react-i18next'
import TableRowCommon from '../../../../components/table/TableRowCommon'
import { alertIcons } from '../../../../assets/icons/icons'
import { renderDate } from '../../../../utils/app.utils'
import moment from 'moment'

type Props = {
    view?: boolean;
}

const ManageBorrowDetail: React.FC<Props> = ({ view }: Props) => {
    const location = useLocation();
    const pathname = location.pathname;
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const base_url = useSelector((state: RootState) => state.api.image_api);
    const { t } = useTranslation();



    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [show_modal, set_show_modal] = useState<boolean>(false);
    const [detail, setDetail] = useState<any>(null);
    const [data, set_data] = useState<any[]>([]);

    const handleCloseModal = () => {
        set_show_modal(false);
    }


    const handleGetDetail = async (id_library_history: number) => {
        dispatch(setLoading());
        await ELibraryManagementApi.findOneBorrowDetail(id_library_history).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || null;
                const id_library_head = response?.id_library_head;

                if (id_library_head) {
                    handleGetListBookedBook(id_library_head);
                }
                setDetail(response);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleConfirmOrder = (id_library_history: number) => {
        alertActive("ยืนยันการรับหนังสือ", "ท่านต้องการยืนยันการรับหนังสือ ใช่หรือไม่", undefined, undefined, async () => {
            dispatch(setLoading());
            await ELibraryManagementApi.confirmOrder(id_library_history).then((res) => {
                if (res.status < 300) {
                    alertSuccess("ยืนยันการรับหนังสือ", "ยืนยันการรับหนังสือ เรียบร้อยแล้ว");
                    navigate(routeName.e_library.manage_borrow);
                }
            }).catch((err) => {
                console.log(err)
                alertError("ยืนยันการรับหนังสือ", "ยืนยันการรับหนังสือ ไม่สำเร็จลองใหม่อีกครั้ง")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleConfirmReturnOrder = (id_library_history: number, id_library_detail: number) => {
        alertActive("ยืนยันการคืนหนังสือ", "ท่านต้องการยืนยันการคืนหนังสือ ใช่หรือไม่", undefined, undefined, async () => {
            dispatch(setLoading());
            await ELibraryManagementApi.returnOrder(id_library_history, { id_library_detail }).then((res) => {
                if (res.status < 300) {
                    set_show_modal(true);
                    // alertSuccess("ยืนยันการคืนหนังสือ", "ยืนยันการคืนหนังสือ เรียบร้อยแล้ว");
                    // navigate(routeName.e_library.manage_borrow);
                }
            }).catch((err) => {
                console.log(err)
                alertError("ยืนยันการคืนหนังสือ", "ยืนยันการคืนหนังสือ ไม่สำเร็จลองใหม่อีกครั้ง")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    // const handleGetListNumberItem = async (id_library_head: number) => {
    //     await ELibraryManagementApi.listNumberItem(id_library_head, LIBRARY_DETAIL_TYPE.RENT).then((res) => {
    //         if (res.status < 300) {
    //             const response = res.data?.data;
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //     })
    // }

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }
    const headCells = [
        {
            id: "id_complaints_type", width: 50, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 100, align: "center", label: t("ชื่อ-นามสกุลผู้ยืม")
        },
        {
            id: "ๅ", disablePadding: false, align: "center", width: 70, label: t("เบอร์โทร")
        },
        {
            id: "1", disablePadding: false, align: "center", width: 70, label: t("เวลาที่จอง")
        },
        {
            id: "2", disablePadding: false, align: "center", width: 70, label: t("วันที่จอง")
        },

    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            full_name,
            phone_number,
            created_date
        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no },
                {
                    option: "TEXT",
                    align: "center",
                    label: full_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: phone_number || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: created_date ? moment(created_date).format("HH:mm") : '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: created_date ? renderDate(created_date) : '-'
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleGetListBookedBook = useCallback(async (id_library_head: number) => {
        let query: booked_book = {
            page: page,
            limit: pageLimit,
        }
        await ELibraryManagementApi.listBookedBook(id_library_head, query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_data(response);
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [page, pageLimit])


    // useEffect(() => {
    //     if (id && !isNaN(+id)) {
    //         handleGetListBookedBook(+id);
    //     }
    // }, [handleGetListBookedBook])

    useEffect(() => {
        if (id && !isNaN(+id)) {
            handleGetDetail(+id);
            // handleGetListNumberItem(+id);
        }
    }, [])

    return (
        <ContainerLayout
            title='รายละเอียดการยืมหนังสือ'
            sub_title_custom={
                <Box className="flex justify-start items-center w-full">
                    <StatusCustom
                        text={detail?.library_history_status || ""}
                        type={detail?.library_history_status || ""}
                        disableMaxWidth
                        sx={{ maxWidth: "fit-content", px: 2 }}
                    />
                </Box>
            }
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "จัดการข้อมูล E-Library",
                            name: "จัดการข้อมูล E-Library",
                            pathName: "",
                            disabled_match: true
                        },
                        {
                            key: "จัดการข้อมูลการยืมหนังสือ",
                            name: "จัดการข้อมูลการยืมหนังสือ",
                            pathName: routeName.e_library.manage_borrow
                        },
                        {
                            key: "รายละเอียดการยืมหนังสือ",
                            name: "รายละเอียดการยืมหนังสือ",
                            pathName: pathname
                        },
                    ]}
                />
            }
            buttonContent={
                <Box className="flex justify-end items-center gap-4">
                    {!view && (
                        <>
                            <Button onClick={() => window.history.length > 0 ? navigate(-1) : navigate(routeName.e_library.manage_orders)} sx={{ borderRadius: "8px" }} variant='outlined'>ย้อนกลับ</Button>
                            {detail?.library_history_status === LIBRARY_HISTORY_STATUS.BORROW ? (
                                <Button
                                    onClick={() => detail?.id_library_history ? handleConfirmReturnOrder(detail?.id_library_history, detail?.id_library_detail) : undefined}
                                    startIcon={<CheckBoxOutlinedIcon />}
                                    color='success'
                                    variant='contained'>ยืนยันการคืนหนังสือ
                                </Button>
                            ) :
                                detail?.library_history_status === LIBRARY_HISTORY_STATUS.WAITING_APPROVE_RETURN ? (
                                    <Button
                                        onClick={() => detail?.id_library_history ? handleConfirmReturnOrder(detail?.id_library_history, detail?.id_library_detail) : undefined}
                                        startIcon={<CheckBoxOutlinedIcon />}
                                        color='success'
                                        variant='contained'>ยืนยันการคืนหนังสือ
                                    </Button>
                                ) :
                                    detail?.library_history_status === LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW ? (
                                        <Button
                                            onClick={() => detail?.id_library_history ? handleConfirmOrder(detail?.id_library_history) : undefined}
                                            startIcon={<CheckBoxOutlinedIcon />}
                                            color='success'
                                            variant='contained'>ยืนยันการรับหนังสือ
                                        </Button>
                                    ) : <></>}
                        </>
                    )}
                </Box>
            }
            content={
                <Box>
                    <Box className="grid grid-cols-12 gap-6">
                        <Box sx={{ minHeight: "575px" }} className="col-span-12 md:col-span-3">
                            <img className='w-full h-full object-cover' src={`${base_url}/${detail?.cover_image?.file_path}/${detail?.cover_image?.file_name}`} alt={detail?.library_head?.library_head_name || ""} />
                        </Box>
                        <Box className="col-span-12 md:col-span-4 flex flex-col  justify-between gap-10">
                            <Box className="flex flex-col gap-4">
                                <Typography variant='h4'>{detail?.library_head?.library_head_name || ""}</Typography>
                                <Typography>
                                    โดย : {detail?.library_head?.library_author_by || "-"}
                                </Typography>
                            </Box>
                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                disabledAllField
                                typeProps={[
                                    {
                                        seq: 1,
                                        gridProps: {
                                            xs: 12
                                        },
                                        type: "TEXT_FIELD",
                                        fieldProps: {
                                            heading: "ผู้ยืม",
                                            value: detail?.full_name || "-"
                                        }
                                    },
                                    {
                                        seq: 2,
                                        gridProps: {
                                            xs: 12
                                        },
                                        type: "TEXT_FIELD",
                                        fieldProps: {
                                            heading: "เลขเรียกหนังสือ",
                                            value: detail?.library_detail_number || "-"
                                        }
                                    },
                                    {
                                        seq: 3,
                                        gridProps: {
                                            xs: 12
                                        },
                                        type: "DATE",
                                        fieldProps: {
                                            onChange: () => { },
                                            heading: "วันที่ยืม",
                                            value: detail?.library_history_date || ""
                                        }
                                    },
                                    {
                                        seq: 4,
                                        gridProps: {
                                            xs: 12
                                        },
                                        type: "DATE",
                                        fieldProps: {
                                            onChange: () => { },
                                            heading: "วันที่คืน",
                                            value: detail?.library_history_return_date || ""
                                        }
                                    },
                                ]}
                            />
                        </Box>
                    </Box>



                    {show_modal && (
                        <ModalCustom
                            handleClose={handleCloseModal}
                            onClick={() => { }}
                            open
                            maxWidth={data?.length > 0 ? 'lg' : "sm"}
                            title='ยืนยันการคืนหนังสือ'
                            subTitle='ยืนยันการคืนหนังสือ เรียบร้อยแล้ว'
                            scrollBody
                            hintSubmitButton
                            icon={<Box my={2}><img src={alertIcons.successAlert} alt='as' /></Box>}
                            custom_cancel_button={
                                <Button
                                    color='success'
                                    onClick={() => navigate(routeName.e_library.manage_borrow)}
                                    fullWidth
                                    variant='contained'>
                                    ตกลง
                                </Button>
                            }
                            enable_up_transition
                            form={
                                data?.length > 0 ?
                                    <Box className="w-full">
                                        <Typography variant='h6' my={2}>
                                            รายชื่อผู้จอง
                                        </Typography>
                                        <TableCustom
                                            tableMinWidth={1050}
                                            tableFixedWidth
                                            customScroll
                                            page={page}
                                            pageLimit={pageLimit}
                                            sortBy={sortBy}
                                            sortType={sortType}
                                            headCells={headCells}
                                            rowCount={totalItems}
                                            rowsData={data?.map((data: any, i: any) => {
                                                return renderData(data, i)
                                            })}
                                            onSort={handleRequestSort}
                                            setPageLimit={(value: number) => setPageLimit(value)}
                                            setPage={(value: number) => setPage(value)}
                                        />
                                    </Box>
                                    : undefined
                            }
                        />
                    )}
                </Box>
            }
        />
    )
}

export default ManageBorrowDetail